module.exports = "<div class=\"sidewidget\">\n  <app-menu [verticalMenu]=\"true\" [slug]=\"'ng_sidemenu'\" [useIcons]=\"true\"></app-menu>\n</div>\n"